import { Grid } from "@material-ui/core";
import { InputTextMaster } from "App/Component/ui";

import React, { useState } from "react";

function TabHistoryAsha() {
  const [formData, setFormData] = useState({
    poli: "",
    ekslusif: "",
  });
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          marginTop: "1.5rem",
        }}>
        <Grid item sm={6}>
          <InputTextMaster
            name='poli'
            label='TGL AWAL KUNJUNGAN'
            id='poli'
            type='date'
            value={formData.poli}
            onChange={handleChange("poli")}
            placeholder='331004650280004'
          />
        </Grid>
        <Grid item sm={6}>
          <InputTextMaster
            name='poli'
            label='TGL AKHIR KUNJUNGAN'
            id='poli'
            type='date'
            value={formData.poli}
            onChange={handleChange("poli")}
            placeholder='331004650280004'
          />
        </Grid>
      </Grid>

      <div
        className='mt-2'
        style={{
          backgroundColor: "#fff",
          padding: "1rem",
          borderRadius: 8,
        }}>
        <p
          style={{
            fontSize: "22px",
            fontWeight: "600",
          }}>
          0001158038291
        </p>
        <p
          style={{
            fontSize: "12px",
            fontWeight: "500",
            letterSpacing: "5",
          }}>
          RAWAT INAP
        </p>
        <table
          style={{
            width: "90%",
            marginTop: "1rem",
            lineHeight: "1.75rem",
            fontSize: "12px",
          }}>
          <tbody>
            <tr>
              <td>Tgl SEP</td>
              <td width='5%'>:</td>
              <td>2021-06-09</td>
            </tr>
            <tr>
              <td>No Rujuk</td>
              <td width='5%'>:</td>
              <td>0223R017 </td>
            </tr>
            <tr>
              <td>Diagnosa</td>
              <td width='5%'>:</td>
              <td>
                <p>
                  Follow - up exam after other treatment for other conditions
                </p>
              </td>
            </tr>

            <tr>
              <td>Kelas</td>
              <td width='5%'>:</td>
              <td>Kelas 3</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        className='mt-2'
        style={{
          backgroundColor: "#fff",
          padding: "1rem",
          borderRadius: 8,
          fontSize: "12px",
        }}>
        <p
          style={{
            fontSize: "22px",
            fontWeight: "600",
          }}>
          0001158038291
        </p>
        <p
          style={{
            fontSize: "12px",
            fontWeight: "500",
            letterSpacing: "5",
          }}>
          RAWAT INAP
        </p>
        <table
          style={{
            width: "80%",
            marginTop: "1rem",
            lineHeight: "2rem",
          }}>
          <tbody>
            <tr>
              <td>Tgl SEP</td>
              <td width='5%'>:</td>
              <td>2021-06-09</td>
            </tr>
            <tr>
              <td>No Rujuk</td>
              <td width='5%'>:</td>
              <td>0223R017 </td>
            </tr>
            <tr>
              <td>Diagnosa</td>
              <td width='5%'>:</td>
              <td>Benign neoplasm of breast</td>
            </tr>

            <tr>
              <td>Kelas</td>
              <td width='5%'>:</td>
              <td>Kelas 3</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export default TabHistoryAsha;
